import React from "react";

import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Shared shell for a rendered data output (table / chart): a titled card with a kind icon,
// cohesive with the R&A neutral palette. Keeps the three bubble variants visually consistent.
export const OutputCard: React.FC<{
	icon: IconDefinition;
	title: string;
	headerRight?: React.ReactNode;
	children: React.ReactNode;
}> = ({ icon, title, headerRight, children }) => (
	<div className="mt-2 overflow-hidden rounded-lg border border-neutral-200 bg-white shadow-sm">
		<div className="flex items-center justify-between gap-2 border-b border-neutral-100 bg-neutral-50 px-4 py-2">
			<div className="flex min-w-0 items-center gap-2">
				<FontAwesomeIcon icon={icon} className="text-sm text-primary-5" />
				<span className="truncate text-sm font-semibold text-neutral-700">{title || "Result"}</span>
			</div>
			{headerRight}
		</div>
		<div className="p-4">{children}</div>
	</div>
);

export default OutputCard;
